import { InboxPlusHeader } from 'owa-mail-list-view';
import FocusedInboxHeader from './FocusedInboxHeader';
import MailListHeaderSecondRowTextContent from './MailListHeaderSecondRowTextContent';
import { observer } from 'mobx-react';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { listViewStore, TableView } from 'owa-mail-list-store';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import * as React from 'react';
import { focusedInboxRollupStore } from 'owa-mail-focused-inbox-rollup-store';
import isInboxPlusEnabled from 'owa-mail-inbox-plus-store/lib/selectors/isInboxPlusEnabled';

export interface MailListFolderHeaderSecondRowContentProps {
    tableViewId: string;
    containerCssClass: string;
    mailListHeaderStylesAsPerUserSettings: string;
}

@observer
export default class MailListFolderHeaderSecondRowContent extends React.Component<
    MailListFolderHeaderSecondRowContentProps,
    {}
> {
    render() {
        const tableView = listViewStore.tableViews.get(this.props.tableViewId);
        return this.renderMailListHeaderDisplay(tableView);
    }

    // Render mail list header
    private renderMailListHeaderDisplay = (tableView: TableView) => {
        const selectedFolderId = tableView.tableQuery.folderId;
        const isInboxSelected = selectedFolderId === folderNameToId('inbox');

        if (isInboxSelected) {
            if (isInboxPlusEnabled()) {
                return (
                    <InboxPlusHeader
                        tableViewId={this.props.tableViewId}
                        mailListHeaderStylesAsPerUserSettings={
                            this.props.mailListHeaderStylesAsPerUserSettings
                        }
                    />
                );
            } else if (isFocusedInboxEnabled()) {
                return (
                    <FocusedInboxHeader
                        unseenCountToDisplay={focusedInboxRollupStore.unseenCountToDisplay}
                        tableViewId={this.props.tableViewId}
                        mailListHeaderStylesAsPerUserSettings={
                            this.props.mailListHeaderStylesAsPerUserSettings
                        }
                    />
                );
            }
        }
        // Render regular folder
        const folder = getSelectedFolder();
        if (!folder) {
            /**
             * This function gets called when when user switches from a favorite persona to a favorite category. At that time, the selected node
             * is set to category node while the table is still persona table. Thus we are expecting the folder to be undefined as the category folder
             * is not saved in folder store.
             */
            return null;
        }

        return this.renderHeader(folder.DisplayName);
    };

    private renderHeader = (headerText: string): JSX.Element => {
        return (
            <MailListHeaderSecondRowTextContent
                text={headerText}
                containerCssClass={this.props.containerCssClass}
            />
        );
    };
}
